import firebase from 'firebase';
import { UserService } from '../auth/userService';
import { ServiceContainer } from '../serviceContainer';
import 'firebase/analytics';

export class TelemetryService {
  private readonly userService: UserService;
  private lastNavTime: number;

  constructor() {
    this.userService = ServiceContainer.get(UserService);
    this.lastNavTime = performance.now();
  }

  public logPageNav(to: string, from: string) {
    const loggedInUser = this.userService.getCurrentUser();
    const telemetryData = {
      userName: loggedInUser ? loggedInUser.displayName : 'Guest',
      userID: loggedInUser ? loggedInUser.uid : null,
      userAgent: navigator.userAgent,
      from: from,
      to: to,
      date: new Date().toISOString(),
      secondsOnPage: ((performance.now() - this.lastNavTime) / 1000).toFixed(2),
    };
    this.lastNavTime = performance.now();
    try {
      firebase.analytics().logEvent('page_navigation', telemetryData);
    } catch (error) {
      console.error('Failed to log telemetry event:', error);
    }
  }
}
